// components/attendance/components/StatusBadge.js
import React from 'react';

const StatusBadge = ({ status }) => {
  const getStatusClass = () => {
    switch (status?.toLowerCase()) {
      case 'present':
        return 'bg-green-100 text-green-800';
      case 'absent':
        return 'bg-red-100 text-red-800';
      case 'late':
        return 'bg-yellow-100 text-yellow-800';
      case 'early_departure':
        return 'bg-blue-100 text-blue-800';
      case 'half_day':
        return 'bg-purple-100 text-purple-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };

  const getStatusText = () => {
    switch (status?.toLowerCase()) {
      case 'present':
        return 'Present';
      case 'absent':
        return 'Absent';
      case 'late':
        return 'Late';
      case 'early_departure':
        return 'Early Departure';
      case 'half_day':
        return 'Half Day';
      default:
        return status || 'Unknown';
    }
  };

  return (
    <span className={`px-2 py-1 text-xs rounded-full ${getStatusClass()}`}>
      {getStatusText()}
    </span>
  );
};

export default StatusBadge;